exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.terms-container[data-v-6672c8dd] {\n    line-height: 1.6;\n    font-size: 16px;\n    color: #333;\n}\n.terms-container h3[data-v-6672c8dd]{\n    margin-bottom: 20px !important;\n}\n.terms-container h4[data-v-6672c8dd] {\n    margin-top: 1.5em;\n    margin-bottom: 0.5em;\n}\n.terms-container p[data-v-6672c8dd] {\n    margin-bottom: 1em;\n}\n.terms-container ol[data-v-6672c8dd],\n.terms-container ul[data-v-6672c8dd] {\n    margin: 0 0 1em 1.5em;\n}\n.terms-container li[data-v-6672c8dd] {\n    margin-bottom: 0.5em;\n}\n.content-box > div[data-v-6672c8dd] {\n    margin-bottom: 2em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6672c8dd","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/TermsContent.vue
// module id = lUrz
// module chunks = 2 3 4 5 6